    
    <div class="modal-body custom-material-form updated-dropdown p-0" >
      <div class="position-relative mb-4">
        @if(activeScreen == 'templateList'){
          <div class="d-flex justify-content-between align-items-center mb-3"> 
            <span class="body-2">Total: {{templateList.length}}</span>
            <button id="createTempAngular" type="button" class="btn btn-sm modal-outline-button waves-effect waves-light m-0" (click)="onCreateTemplate()">Create New Template</button>
          </div>
          <div class="divider mb-2"></div>
          @if(templateList.length){
            <mdb-tabs class="custom-reminder-tabs">
              <mdb-tab title="Active">
                @if(templateActiveList.length){
                  <ul class="list-group list-group-light" style="max-height: 400px; overflow:scroll;">       
                      @for(template of templateActiveList; track template) {
                        <li class="list-group-item template-item mb-1 p-2 d-flex flex-row align-items-center">
                          <div class="template-item_container">
                              <div class="template-item__name mb-1">{{template.name}}</div>
                              <div class="template-item__subject mb-1"><span class="grey-text">Subject: </span>{{template.subject | transformString}}</div>
                          </div>
                          <div class="d-flex flex-row ml-auto">
                            <button class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2" (click)="editTemplate(template)" 
                              style="border: 1px solid rgba(0, 0, 0, 0.08); width: 36px; height: 36px; box-shadow: none;">
                              <i class="fas fa-pencil-alt p2p-popover-icon d-flex align-items-center cursor--pointer"></i>
                            </button>
                            <button class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2" (click)="onDeleteTemplateClick(template)" 
                              style="border: 1px solid rgba(0, 0, 0, 0.08); width: 36px; height: 36px; box-shadow: none;">
                              <i class="black-text far fa-trash-alt p2p-popover-icon cursor--pointer"></i>
                            </button>
                          </div>
                        </li>
                      }
                  </ul>
                }@else{
                  <span class="body-1 d-flex justify-content-center">You do not have active Templates</span>
                }
              </mdb-tab>
              <mdb-tab title="Inactive">
                @if(templateInActiveList.length){
                  <ul class="list-group list-group-light" style="max-height: 400px; overflow:scroll;">
                    @for(template of templateInActiveList; track template) {
                      <li class="list-group-item template-item mb-1 p-2 d-flex flex-row align-items-center">
                        <div class="template-item_container">
                            <div class="template-item__name mb-1">{{template.name}}</div>
                            <div class="template-item__subject mb-1"><span class="grey-text">Subject: </span>{{template.subject}}</div>
                        </div>
                        <div class="d-flex flex-row ml-auto">
                          <button class="btn btn--table-action d-flex align-items-center justify-content-center px-2 p-0 my-0 ml-0 mr-2" (click)="onDeleteTemplateClick(template,true)" 
                            style="border: 1px solid rgba(0, 0, 0, 0.08); height: 36px; font-size: 12px!important; box-shadow: none;">
                            Activate
                          </button>
                          <button class="btn btn--table-action d-flex align-items-center justify-content-center p-0 my-0 ml-0 mr-2" (click)="editTemplate(template)" 
                            style="border: 1px solid rgba(0, 0, 0, 0.08); width: 36px; height: 36px; box-shadow: none;">
                            <i class="fas fa-pencil-alt p2p-popover-icon d-flex align-items-center cursor--pointer"></i>
                          </button>
                        </div>
                      </li>
                    }
                  </ul>
                }@else{
                  <span class="body-1 d-flex justify-content-center">You do not have inactive Templates</span>
                }
              </mdb-tab>
            </mdb-tabs>
          }@else{
            <span class="body-1 d-flex justify-content-center">You do not have saved Templates. Please create one.</span>
          }
        }
        
        @if(activeScreen != 'templateList'){
            <div class="position-relative mb-4 px-2">
              <div class="name-block mb-2">
              <mdb-form-control>
                <label class="mb-1 body-1">Template Name</label>
                <app-mdbp-input mdbInput [formControl]="customReminderName"></app-mdbp-input>
                @if (customReminderName.invalid) {
                  <mdb-error class="form-fill-error">Please provide Name</mdb-error>
                }
              </mdb-form-control>
              </div>
              <div class="subject-block mb-2">
                <div class="d-flex align-items-end justify-content-between">
                  <label class="form-check-label form-check-label--paybee mb-1  body-1">Email Subject</label>
                  <div class="d-flex justify-content-between align-items-center" style=" top: 4px; right: 4px;">
                    <div style="width: 200px;" class="ml-auto"> 
                      <select #insertTypeSubject id='insertTypeSubject' class='select-wrapper mdb-select mdb-select--paybee mb-1 w-100'>
                          <option value="insertSubject" disabled>+ Insert Element</option>
                          @for (item of insertSubjectBlocks; track item) {
                            <option [value]="item.value">{{item.name}}</option>
                          } 
                      </select>
                    </div>
                  </div> 
                </div>
                <mdb-form-control class="position-relative">
                  <app-quill-custom mdbInput [formControl]="customReminderSubject" [options]="quillSubjectOptions" class="hiddenToolbar" limit="256"></app-quill-custom>
                  @if(customReminderSubject.invalid){<mdb-error class="form-fill-error top">Please provide Subject</mdb-error>}
                </mdb-form-control>
              </div>
              <div class="body-block mb-2">
                <div class="d-flex align-items-end justify-content-between">
                    <label class="form-check-label form-check-label--paybee mb-1  body-1">Email Body</label>
                    <div style="width: 200px;" class="ml-auto"> 
                      <select #insertTypeBody id='insertTypeBody' class='select-wrapper mdb-select mdb-select--paybee mb-1 w-100'>
                          <option value="insertBody" disabled>+ Insert Element</option>
                           @for (item of insertBodyBlocks; track item) {
                              <option [value]="item.value">{{item.name}}</option>
                          }
                      </select>
                    </div>
                </div>
                <mdb-form-control class="position-relative">
                    <app-quill-custom mdbInput [formControl]="customReminderBody" [options]="quillBodyOptions" limit="2048"></app-quill-custom>
                    @if(customReminderBody.invalid) {
                      <mdb-error class="form-fill-error top">Please provide Body</mdb-error>
                    }
                </mdb-form-control>
              </div>
            </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      @if(activeScreen == 'templateList'){
        <button type="button" class="btn btn-sm modal-outline-button waves-effect waves-light m-0 mr-2" style="width: 140px;" (click)="onBackClick()">Back</button>
      }

      <div class="d-flex flex-row justify-content-between w-100">
        @if(activeScreen == 'createTemplate'){
        <a class="btn btn--paybee btn--green button waves-effect waves-light" (click)="onClickCreateOrUpdate('create', true)">Save and Preview</a>
        
        <div>
          <button type="button" class="btn btn-sm modal-outline-button waves-effect waves-light m-0 mr-2" (click)="goToTemplateList()">Back</button>
            <button type="button" class="btn btn-sm modal-confirm-button waves-effect waves-light m-0" (click)="onClickCreateOrUpdate('create')">Create Template</button>  
          </div>
          }

          @if(activeScreen == 'updateTemplate'){
          <a class="btn btn--paybee btn--green button waves-effect waves-light" (click)="onClickCreateOrUpdate('update', true)">Save and Preview</a>
          
          <div class="d-flex flex-row">
            <button type="button" class="btn btn-sm modal-outline-button waves-effect waves-light m-0 mr-2"  (click)="goToTemplateList()">Back</button>
            <button type="button" class="btn btn-sm modal-confirm-button waves-effect waves-light m-0" (click)="onClickCreateOrUpdate('update')">Update Template</button>
        </div>
        }
      </div>
    </div> 